import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as contactReducer } from '../common/store/contacts/reducer';
import { reducer as birthdayReducer } from '../common/store/birtydays/reducer';
import { reducer as medicalExaminationReducer } from '../common/store/medicalExaminations/reducer';
import { reducer as trainerReducer } from '../common/store/trainers/reducer';
import { reducer as reminderReducer } from '../common/store/reminders/reducer';
import { reducer as infosReducer } from '../common/store/infos/reducer';
import { reducer as accessReducer } from '../common/store/accesses/reducer';
import { reducer as tagReducer } from '../scenes/tags/store/reducer';
import { reducer as authReducer } from '../common/Auth0/store/reducer';
import { reducer as postReducer } from '../common/store/posts/reducer';
import { reducer as userStatsReducer } from '../common/store/userstats/reducer';
import { reducer as chatReducer } from '../scenes/chat/store/reducer';
import { reducer as roomReducer } from '../scenes/room/store/reducer';
import { reducer as reservationReducer } from '../scenes/reservation/store/reducer';
import { reducer as activitiesReducer } from '../scenes/activities/store/reducer';
import { reducer as activitiesReservationReducer } from '../scenes/activityReservations/store/reducer';
import { reducer as subscriptionReducer } from '../common/store/subscriptions/reducer';
import { reducer as notificationReducer } from '../common/store/notification/reducer';

// export interface IBaseReducer {
//     reducerKey: string;
//     reducerFunction: any;
// }
// let routing = routerReducer;
let reduc = (history) => ({
    router: connectRouter(history),
    contacts: contactReducer,
    birthdays: birthdayReducer,
    medicalExaminations: medicalExaminationReducer,
    trainers: trainerReducer,
    reminders: reminderReducer,
    infos: infosReducer,
    accesses: accessReducer,
    tags: tagReducer,
    auth: authReducer,
    posts: postReducer,
    rooms: roomReducer,
    reservations: reservationReducer,
    chatmessages: chatReducer,
    userstats: userStatsReducer,
    activities: activitiesReducer,
    activityReservations: activitiesReservationReducer,
    subscriptions: subscriptionReducer,
    notification: notificationReducer,
});

export const localReducers = (history) => combineReducers(reduc(history));